import styled from 'styled-components';

export const RowActionButton = styled.button`
  position: fixed;
  padding: 0;
  width: 20px;
  height: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.primary.main};
  border: none;
  outline: none;
`;

export const ColumnActionButton = styled.button`
  position: fixed;
  padding: 0;
  width: 26px;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.primary.main};
  border: none;
  outline: none;
`;

export const ActionMenu = styled.div`
  position: fixed;
  z-index: 1002;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0 5px 50px 0 ${({ theme }) => theme.palette.grey[200]};
`;

export const MenuItem = styled.button`
  padding: 4px 8px;
  color: ${({ theme }) => theme.palette.text.primary};
  cursor: pointer;
  font-size: 14px;
  border: none;
  background-color: transparent;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const MenuBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
`;
